import React from "react";
import "./DocumentBrowse.scss";
import ErrMsg from "../ErrMsg/ErrMsg";
import ProgressBar from "../ProgressBar/ProgressBar";
import pngIcon from "../../../assets/icons/png.png";
import jpgIcon from "../../../assets/icons/jpg.png";
import pdfIcon from "../../../assets/icons/pdf.png";
import Backdrop from "../Backdrop/Backdrop";
import prevIcon from "../../../assets/icons/eye.png";
import cropIcon from "../../../assets/icons/crop.png";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Button from "../Button/Button";
import DeviceContext from "../../Services/identifyDevice";
import GlobalStore from "../../store/globalStore";
import Loader from "./../Loader/Loader";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";

export interface DocDetailFormat {
  id: string;
  disable?: boolean;
  isImageOnly?: boolean;
  uploadPer: number;
  hideProgress: boolean;
  fileName: string;
  showFile: boolean;
  imgUrl: any;
  documentCategoryId?: string;
  documentId?: number;
  DocumentId?: number;
  mimeType?: string;
  documentcategory?: string;
  base64?: string;
  iscropped?: boolean;
  isWatsappFlag?: boolean;
  isElogSignOpted?: boolean;
}
export interface DocumentBrowseProps {
  id: string;
  docType?: string;
  extensionTypes?: string;
  docObj: DocDetailFormat;
  onDocUploadComplete?: (
    value: any,
    fileName: string,
    id: string,
    type: string,
    // true when the cropper is about to open; "Crop and Upload" calls again with the cropped image
    isCropPending?: boolean
  ) => void;
  isRemove?: (docObj: DocDetailFormat) => void;
  removePanImg?: boolean;
  previewImageexternalClassName?: string;
  mandateRemove?: boolean;
  disableRemove?: boolean;
  errorMsgCode?: string;
  isCropDisabled?: boolean;
}

const DocumentBrowse: React.FC<DocumentBrowseProps> = (props) => {
  const [cropper, setCropper] = React.useState<any>();
  const [docErrorMsg, setDocErrorMsg] = React.useState<string | number>("");
  // const [prevImage, setPrevImage] = React.useState<any>(props.docObj.imgUrl);
  const [prevImage, setPrevImage] = React.useState<any>();
  const [loadingFlag, setLoadingFlag] = React.useState<boolean>(
    props.docObj.showFile
  );
  const [docName, setDocName] = React.useState<string>(props.docObj.fileName);
  // const [ext, setExt] = React.useState<String>(props.docObj.mimeType === "application/pdf" ? "PDF" : "");
  const [ext, setExt] = React.useState<String>("");
  // Preview / cropper dialogs are mounted only while open. Keeping them mounted
  // (hidden) left their Escape handlers live, so Escape anywhere on the page
  // ran the cropper's close handler and removed every uploaded document.
  const [showPreview, setShowPreview] = React.useState(false);
  const [showCrop, setShowCrop] = React.useState(false);
  // true while the cropper shows a just-selected file that is not saved yet;
  // only then does closing the cropper discard the file
  const cropIsNewUploadRef = React.useRef(false);
  // highlights the drop zone while a file is dragged over it (the file input
  // covering the zone receives the drop natively)
  const [isDragOver, setIsDragOver] = React.useState(false);

  const minContainerWidth: number = DeviceContext().isMobile ? 300 : 500;
  const minContainerHeight: number = DeviceContext().isMobile ? 150 : 250;
  const minCanvasWidth: number = DeviceContext().isMobile ? 200 : 400;
  const minCanvasHeight: number = DeviceContext().isMobile ? 200 : 400;
  const minCropBoxWidth: number = DeviceContext().isMobile ? 100 : 100;
  const minCropBoxHeight: number = DeviceContext().isMobile ? 100 : 100;

  const zoomIn = () => {
    cropper?.zoom(0.1);
  };

  const zoomOut = () => {
    cropper?.zoom(-0.1);
  };

  const rotateLeft = () => {
    cropper?.rotate(-90);
  };

  const rotateRight = () => {
    cropper?.rotate(90);
  };

  const resetCropper = () => {
    cropper?.reset();
  };

  React.useEffect(() => {
    if (props.docObj.mimeType === "application/pdf") {
      setExt("PDF");
    }
    if (
      props?.docObj?.fileName !== null &&
      props?.docObj?.fileName !== undefined &&
      props?.docObj?.fileName !== ""
    ) {
      setDocName(props?.docObj?.fileName);
    }
  }, []);
  React.useEffect(() => {
    setLoadingFlag(props.docObj.showFile);
  }, [props.docObj.showFile, props.docObj]);
  React.useEffect(() => {
    if (
      props?.docObj?.fileName !== null &&
      props?.docObj?.fileName !== undefined &&
      props?.docObj?.fileName !== ""
    ) {
      setDocName(props?.docObj?.fileName);
    }
  }, [props?.docObj?.fileName]);
  React.useEffect(() => {
    if (props.removePanImg) {
      removeDoc();
    }
  }, [props.removePanImg]);

  function onFileUpload(event: React.ChangeEvent<HTMLInputElement>) {
    setIsDragOver(false);
    if (props?.disableRemove) {
    } else {
      const elem = event.target;
      const file = elem.files && elem.files[0];
      if (file) {
        setDocName(file.name);
      }

      if (file && file.size > 5242880) {
        setDocErrorMsg(errorMsg(errorCode.FE47));
        return;
      }
      if (file && file.name.split(".").length === 2) {
        let extensions = file.name.split(".");
        if (props.docObj.documentId === 305 || props.docObj.DocumentId === 305) {
          if (file.size > 1048576) {
            setDocErrorMsg(errorMsg(errorCode.FE47));
            return;
          } else if (extensions[1].toUpperCase() === "PDF") {
            setDocErrorMsg(errorMsg(errorCode.FE13));
            return;
          }
        }
        let docTypeArray: any[] = [];
        if (
          props?.extensionTypes !== null &&
          props?.extensionTypes !== undefined
        ) {
          docTypeArray = props?.extensionTypes.split(",");
        }

        if (
          props?.extensionTypes !== null &&
            props?.extensionTypes !== undefined &&
            docTypeArray?.length > 0
            ? extensions[1].toUpperCase() === docTypeArray[0] ||
            (!!docTypeArray[1] &&
              docTypeArray[1] !== "" &&
              extensions[1].toUpperCase() === docTypeArray[1])
            : extensions[1].toUpperCase() === "JPG" ||
            extensions[1].toUpperCase() === "JPEG" ||
            extensions[1].toUpperCase() === "PDF"
        ) {
          setExt(extensions[1].toUpperCase());

          if (elem.files && elem.files[0]) {
            setDocErrorMsg("");
            let data = new FormData();
            data.append("file", elem.files[0]);
            const reader = new FileReader();
            setLoadingFlag(true);

            reader.onload = function (e) {
              const images = (e.target && e.target.result)?.toString();
              if (images) {
                setPrevImage(images);
              }
              setLoadingFlag(false);
              // !file.type.startsWith("image/") &&
              props.id !== "signature" &&
                props.onDocUploadComplete &&
                props.onDocUploadComplete(
                  images,
                  file.name,
                  props.id,
                  file.type,
                  file.type.startsWith("image/") && !props.isCropDisabled
                );
            };
            reader.readAsDataURL(elem.files[0]);
          }
        } else {
          if (props.docObj.id == "photo" && props?.errorMsgCode !== "" && !!props?.errorMsgCode) {
            setDocErrorMsg(errorMsg(errorCode.FE49));
          } else if (props.docObj.id !== "signature") {
            setDocErrorMsg(errorMsg(errorCode.FE14));
          } else {
            setDocErrorMsg(errorMsg(errorCode.FE13));
          }
          return;
        }
      } else {
        setDocErrorMsg(errorMsg(errorCode.FE15));
        return;
      }
      // if (props.id === 'signature' || file.name.split(".")[1].toUpperCase() === "JPG" || file.name.split(".")[1].toUpperCase() === "JPEG") {
      //     handleCropping(file.type);
      // }
      // if (props.id === "signature") {
      if (file && file.type.startsWith("image/") && !props.isCropDisabled) {
        cropIsNewUploadRef.current = true;
        handleCropping(file.type);
      }
      // }
    }
  }

  const removeDoc = () => {
    setLoadingFlag(true);
    // let updateProps = {...props};
    props.docObj.uploadPer = 0;
    props.isRemove && props.isRemove(props.docObj);
    // setPrevImage(undefined);
    // setExt("");
    // props.docObj.hideProgress = true;
  };

  const closeSample = () => {
    setShowPreview(false);
    setShowCrop(false);
  };

  // Closing the cropper without "Crop and Upload": a freshly selected file is
  // discarded (as before); an already-saved document stays as it is.
  const cancelCrop = () => {
    closeSample();
    if (cropIsNewUploadRef.current) {
      cropIsNewUploadRef.current = false;
      removeDoc();
    }
  };

  const handleCropping = (mimetype?: string) => {
    const type = mimetype || props.docObj.mimeType;
    const isImage = type?.startsWith("image/");
    if (!isImage) {
      // Show preview for PDF
      setShowPreview(true);
      setShowCrop(false);
    } else {
      // Show cropper only for images
      setShowPreview(false);
      setShowCrop(true);
    }
  };

  // Clicking an uploaded tile previews it; only the signature opens the cropper.
  // Cropping on file select is still triggered from onFileUpload.
  const openUploadedDoc = () => {
    cropIsNewUploadRef.current = false;
    if (props.id === "signature") {
      setShowPreview(false);
      setShowCrop(true);
    } else {
      setShowPreview(true);
      setShowCrop(false);
    }
  };

  const getCropData = () => {
    if (cropper) {
      const croppedImage = cropper
        .getCroppedCanvas()
        .toDataURL(props.docObj.mimeType);

      setPrevImage(croppedImage);

      props.docObj.iscropped = true;
      props.docObj.base64 = croppedImage;

      saveCroppedImage(croppedImage);
    }
  };

  const saveCroppedImage = (croppedImage: string) => {
    props.docObj.imgUrl = croppedImage;

    const cropImgtype = croppedImage.substring(
      "data:image/".length,
      croppedImage.indexOf(";base64")
    );

    props.onDocUploadComplete?.(
      croppedImage,
      docName, // use state value
      props.id,
      cropImgtype
    );

    cropIsNewUploadRef.current = false;
    closeSample();
  };

  // Base64 of a PDF always starts with "JVBERi0" ("%PDF-"). Backend MimeType can be
  // "", "." or wrong, so detect PDFs from the data itself and build a valid PDF data URL.
  const getPdfDataUrl = (url?: string) => {
    if (!url || !url.startsWith("data:")) return undefined;
    if (url.startsWith("data:application/pdf")) return url;
    const payload = url.split(",")[1];
    return payload?.startsWith("JVBERi0")
      ? `data:application/pdf;base64,${payload}`
      : undefined;
  };
  const pdfSrc = getPdfDataUrl(prevImage) || getPdfDataUrl(props.docObj.imgUrl);
  const isPdf =
    !!pdfSrc ||
    ((ext === "PDF" ||
      props.docObj.mimeType?.toLowerCase().includes("pdf")) &&
      !props.docObj.imgUrl?.startsWith("data:image"));

  // Chrome renders large data: PDFs as a blank page, so preview through a Blob URL.
  const [pdfBlobUrl, setPdfBlobUrl] = React.useState<string>();
  React.useEffect(() => {
    if (!pdfSrc) return;
    let blobUrl: string | undefined;
    try {
      const binary = atob(pdfSrc.split(",")[1]);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      blobUrl = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      setPdfBlobUrl(blobUrl);
    } catch (err) {
      console.error("Unable to build PDF preview", err);
    }
    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      setPdfBlobUrl(undefined);
    };
  }, [pdfSrc]);
  // data: URLs are not allowed in frames (CSP frame-src, and Chrome blocks
  // data: PDFs), so frame the blob URL, or a plain URL if that is all there is
  const pdfFrameSrc: string | undefined =
    pdfBlobUrl ||
    [prevImage, props.docObj.imgUrl].find(
      (u) => typeof u === "string" && u !== "" && !u.startsWith("data:")
    );

  return (
    <div className="docBrowseLayout">
      <Backdrop
        isShow={showPreview}
        isCloseIcon={true}
        onClose={closeSample}
        ariaLabel={`${docName || "Document"} preview`}
      >
        <>
          {isPdf ? (
            // <iframe>, not <embed>: the CSP has object-src 'none', which blocks
            // <embed>/<object> on UAT/prod; frame-src allows 'self' and blob:
            pdfFrameSrc ? (
              <iframe
                key={pdfFrameSrc}
                src={pdfFrameSrc}
                className="pdfMaxSize"
                title={`${docName || "Document"} preview`}
              />
            ) : (
              <Loader size={20} />
            )
          ) : (
            <div className="">
              <img
                className={
                  props?.previewImageexternalClassName
                    ? props?.previewImageexternalClassName
                    : "maxSize"
                }
                src={props.docObj.imgUrl || prevImage}
                alt={`${docName || "Document"} preview`}
              />
            </div>
          )}
        </>
      </Backdrop>
      <Backdrop
        isShow={showCrop}
        isCloseIcon={true}
        onClose={cancelCrop}
        ariaLabel={`Crop ${docName || "document"}`}
      >
        <div className="cropPrev">
          {prevImage || props.docObj.imgUrl ? (
            <Cropper
              // style={DeviceContext().isMobile ? { height: "150px", width: "300px" } : {}}
              initialAspectRatio={2}
              preview=".img-preview"
              src={prevImage || props.docObj.imgUrl}
              viewMode={1}
              guides={true}
              minContainerWidth={minContainerWidth}
              minContainerHeight={minContainerHeight}
              minCanvasWidth={minCanvasWidth}
              minCanvasHeight={minCanvasHeight}
              minCropBoxWidth={minCropBoxWidth}
              minCropBoxHeight={minCropBoxHeight}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
              onInitialized={(instance) => {
                setCropper(instance);
              }}
              dragMode="move"
              cropBoxResizable={true}
              cropBoxMovable={true}
              zoomOnWheel={true}
              toggleDragModeOnDblclick={false}
            />
          ) : (
            <div>
              <Loader size={20} />
            </div>
          )}
        </div>
        <div className="funcBtns" role="group" aria-label="Adjust image">
          {/* <div style={{ marginBottom: "10px" }}>
            <button onClick={zoomOut} style={{ marginLeft: 10 }}>-</button>
            <button onClick={zoomIn} style={{ marginLeft: 5 }}>+</button>
          </div> */}

          <Button btnName="⟲" ariaLabel="Rotate left" onClick={rotateLeft} />
          <Button btnName="⟳" ariaLabel="Rotate right" onClick={rotateRight} />
          <Button btnName="Reset" ariaLabel="Reset crop" onClick={resetCropper} />
        </div>
        <Button btnName="Crop and Upload" onClick={() => getCropData()} />
      </Backdrop>

      {loadingFlag ? (
        <div
          className={
            "docBrowse " +
            (props.docObj.disable ? " disable" : "") +
            (isDragOver ? " dragOver" : "")
          }
          onDragEnter={() => !props.docObj.disable && setIsDragOver(true)}
          onDragLeave={() => setIsDragOver(false)}
          onDrop={() => setIsDragOver(false)}
        >
          <input
            type="file"
            disabled={props.docObj.disable}
            id={props.docObj.id}
            className="fileInput"
            onChange={onFileUpload}
            accept={
              props?.docType !== undefined && props?.docType !== null
                ? props?.docType
                : "image/jpeg, image/jpg, .pdf"
            }
            aria-label={`Upload ${docName || "document"}`}
            aria-invalid={docErrorMsg ? true : undefined}
            aria-describedby={docErrorMsg ? `${props.docObj.id}-error` : undefined}
          />
          <label className="dragLbl" htmlFor={props.docObj.id}>
            {DeviceContext().isMobile ? (
              <>
                TAP TO<span className="dragLbl browse">UPLOAD</span>
              </>
            ) : (
              <>
                DRAG FILE HERE OR<span className="dragLbl browse">BROWSE</span>
              </>
            )}
          </label>
          <br />
          {props.id === "signature" ? (
            <span className="dragLbl">JPG, JPEG (Max size: 1MB)</span>
          ) : (
            <>
              {props?.docType !== undefined && props?.docType !== null ? (
                <span className="dragLbl">
                  {props?.docType}(Max size: 5MB)
                </span>
              ) : (
                <span className="dragLbl">
                  PDF, JPG, JPEG (Max size: 5MB)
                </span>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="uploadSec">
          <div className="flexConatiner">
            <div className="imgSec">
              {props.docObj.uploadPer !== 100 ? (
                (ext === "PDF" && (
                  <img src={pdfIcon} alt="" aria-hidden="true" />
                )) ||
                (ext === "JPG" && (
                  <button
                    type="button"
                    className="docThumbBtn"
                    onClick={openUploadedDoc}
                    aria-label={`Preview or crop ${docName || "image"}`}
                  >
                    <img src={jpgIcon} alt="" aria-hidden="true" />
                  </button>
                ))
              ) : (
                <button
                  type="button"
                  className="container docThumbBtn"
                  onClick={openUploadedDoc}
                  aria-label={
                    props.id !== "signature"
                      ? `Preview ${docName || "document"}`
                      : `Crop ${docName || "signature"}`
                  }
                >
                  {isPdf ? (
                    <img className="thumbnail" src={pdfIcon} alt="" aria-hidden="true" />
                  ) : (
                    <img
                      className="thumbnail"
                      src={props.docObj.imgUrl || prevImage}
                      alt=""
                      aria-hidden="true"
                    />
                  )}
                  <div className="middle">
                    <div className="text">
                      {props.id !== "signature" ? (
                        <img src={prevIcon} alt="" aria-hidden="true" />
                      ) : (
                        <img src={cropIcon} alt="" aria-hidden="true" />
                      )}
                    </div>
                  </div>
                </button>
              )}
            </div>
            <div className="uploading">
              <span className="docNameLbl">{docName}</span>
              {props.docObj.hideProgress && (
                <div className="mrt8">
                  <ProgressBar
                    percent={props.docObj.uploadPer.toString()}
                    width="120px"
                    height="4px"
                    isBlueColor
                    ariaLabel={`${docName || "Document"} upload progress`}
                  />
                </div>
              )}
            </div>
            {(!props.docObj.disable || props.mandateRemove) && !props?.disableRemove && (
              <button
                type="button"
                className={"cancelSec"}
                onClick={() => {
                  if (props?.disableRemove) {
                  } else {
                    removeDoc();
                  }
                }}
                aria-label={
                  props.docObj.hideProgress
                    ? `Cancel ${docName || "upload"}`
                    : `Remove ${docName || "document"}`
                }
              >
                <span className="cancelBtn">
                  {props.docObj.hideProgress ? "Cancel" : "Remove"}
                </span>
                <span className="cancelIcon edel-icon-close closeIcon" aria-hidden="true"></span>
              </button>
            )}
          </div>
        </div>
      )}
      {/* Error Msg Start*/}
      {docErrorMsg && (
        // ErrMsg is the live region; a second alert here made it announce twice
        <div className="errMsgBlck" id={`${props.docObj.id}-error`}>
          <ErrMsg>
            {typeof docErrorMsg === "number" ? (
              <>
                <span>We are facing some technical issue.</span>
                <span>
                  Please try after sometime (error code:{docErrorMsg})
                </span>
              </>
            ) : (
              <span>{docErrorMsg}</span>
            )}
          </ErrMsg>
        </div>
      )}
      {/* Error Msg End*/}
    </div>
  );
};

export default DocumentBrowse;
